import React from 'react'
import Header from '../common/Header'
import Footer from '../common/Footer'
import CommonHeroSection from '../common/CommonHeroSection'
import CommonBreadcrumb from '../common/CommonBreadcrumb'
import ContactSection from '../sections/ContactSection'

const ContactUs = () => {
    return (
        <>
            <Header />
            {/* <CommonHeroSection title="Contact Us" /> */}
            <CommonBreadcrumb items={["Contact Us"]} />
            <ContactSection />
            <Footer />
        </>
    )
}

export default ContactUs